<script lang="ts" setup>
import { theme as brandTheme } from '@/config/brands'

const props = defineProps<{
  config: any
  des: string
  email: string
  loading: boolean
  handleConfirm: () => void
}>()

const emit = defineEmits<{
  (event: 'update:des', value: string): void
  (event: 'update:email', value: string): void
}>()

function onDesInput(event: Event) {
  emit('update:des', (event.target as HTMLTextAreaElement).value)
}

function onEmailInput(event: Event) {
  emit('update:email', (event.target as HTMLInputElement).value)
}

const bgPrimary = props.config.colors.bgPrimary
const bgTertiary = props.config.colors.bgTertiary
const textPrimary = props.config.colors.textPrimary
const textPlaceholder = props.config.colors.textPlaceholder
const accentRed = props.config.colors.accentRed
const primaryColor = props.config.colors.primaryColor
const whiteColor = props.config.colors.whiteColor
const pageBgColor = brandTheme.bgGlobal || '#14181F'
</script>

<template>
  <div class="contact-us-page">
    <div class="form-container">
      <div class="form-item">
        <div class="form-title">
          <span class="required">*</span>{{ config.texts.feedbackTitle }}
        </div>
        <div class="textarea-wrapper">
          <textarea
            :value="des"
            class="form-textarea rr-contact-field"
            :placeholder="config.texts.feedbackPlaceholder"
            maxlength="100"
            @input="onDesInput"
          />
        </div>
      </div>

      <div class="form-item">
        <div class="form-title">
          <span class="required">*</span>{{ config.texts.emailTitle }}
        </div>
        <input
          :value="email"
          type="text"
          class="form-input rr-contact-field"
          :placeholder="config.texts.emailPlaceholder"
          @input="onEmailInput"
        >
      </div>

      <button
        :disabled="des === '' || email === '' || loading"
        class="submit-btn"
        :class="{ 'submit-btn-loading': loading }"
        @click="handleConfirm"
      >
        {{ loading ? config.texts.submittingButton : config.texts.submitButton }}
      </button>
    </div>
  </div>
</template>

<style scoped>
.contact-us-page {
  min-height: 100vh;
  background: v-bind(pageBgColor) !important;
}

.form-container {
  padding: 14px 14px 40px;
}

.form-item {
  margin-bottom: 22px;
}

.form-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: v-bind(textPrimary);
}

.required {
  color: v-bind(accentRed);
}

.textarea-wrapper {
  position: relative;
}

.form-textarea {
  width: 100%;
  height: 260px;
  border: none;
  border-radius: 18px;
  background: v-bind(bgTertiary);
  color: v-bind(textPrimary);
  font-size: 14px;
  line-height: 22px;
  padding: 16px;
  resize: none;
  box-sizing: border-box;
}

.form-input {
  width: 100%;
  height: 56px;
  border: none;
  border-radius: 18px;
  background: v-bind(bgTertiary);
  color: v-bind(textPrimary);
  font-size: 14px;
  line-height: 56px;
  padding: 0 16px;
  box-sizing: border-box;
}

.form-textarea::placeholder,
.form-input::placeholder {
  color: v-bind(textPlaceholder);
}

.form-textarea:focus,
.form-input:focus {
  outline: 2px solid rgba(255, 107, 61, 0.28);
}

.submit-btn {
  width: 100%;
  height: 48px;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(90deg, #ff8a4c 0%, v-bind(primaryColor) 100%);
  color: #FFFFFF !important;
  font-size: 16px;
  line-height: 48px;
  font-weight: 600;
  margin-top: 24px;
}

.submit-btn:disabled {
  opacity: 0.45;
}

.submit-btn-loading {
  opacity: 0.75;
}
</style>
